<template>
    <v-bottom-sheet v-model="$store.state.bookingSelectServiceDialogStatus" hide-overlay elevation="0">
      <v-card color="white" rounded="t-xl">
        <v-card-text class="px-1 pt-0">
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-card variant="text">
                <v-card-actions>
                  <h3>{{ $t('select_service') }} <span class="text-caption text-pink">({{ $store.state.employe.title }})</span></h3>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="$store.commit('setBookingSelectServiceDialogStatus', false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text class="px-1">
                  <v-row
                    v-if="!!$store.state.employe && !!$store.state.employe.options && !!$store.state.employe.options.services">
                    <v-col cols="12" md="6"
                      v-for="(serive, index) in $store.state.info.serives.filter(e => $store.state.employe.options.services.map(s => s.id).includes(e.id))"
                      :key="index">
                      <v-card class="pa-2" color="white" elevation="3" rounded="lg">
                        <div class="d-flex flex-column text-center">
                          <div class="d-flex align-center justify-space-between text-center">
                            <div class="d-flex align-center">
                              <v-avatar class="mr-4">
                                <v-img :src="$store.state.fileBaseUrl+serive.image" cover />
                              </v-avatar>
                              <h4 class="mr-4">{{ serive.title }}</h4>
                            </div>
                          </div>
                          <v-btn  elevation="5" color="primary" rounded="lg" class="mt-4"
                            @click="$store.commit('setService', serive); $store.commit('setBookingDialogStatus', true); $store.commit('setBookingSelectServiceDialogStatus', false);">
                            {{ $t('select_and_continue') }}
                          </v-btn>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-alert v-else type="warning" elevation="3">
                    {{ $t('no_active_services') }}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </template>
  
  <script>
  export default {
    name: "SelectServicePage",
    
  }
  </script>
  
  <style>
  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 30px !important;
  }
  </style>
  